export default {
    computed: {
        project() {
            try {
                return this.$store.getters.getProjectById(this.projectId)
            } catch (e) {
                console.warn(e)
            }
        },
        projectType() {
            try {
                return this.$store.getters.projectTypeById(this.project.projectType.id)
            } catch (e) {
                return {}
            }
        },
        projectTasks() {
            return this.$store.getters.tasksByProjectId(this.projectId)
        },
        projectComments() {
            return this.$store.getters.commentsForEntity(this.projectId)
        },
        projectAttachments() {
            return this.$store.getters.attachmentByEntityId(this.projectId)
        },
    },
}
